import { Aux } from '../../../AuxillaryService';

export const GlobalAux = {
    Service<TService>(name: string): TService {
        return Aux.Service(name);
    },
};
